import svg4everybody from 'svg4everybody';
import './outdatedbrowser';
import './modules/cookie-consent';

// Init svg4everybody
svg4everybody();

/**
 * Polyfills
 */
if (!Array.from) {
  import(/* webpackChunkName: "polyfill-array-form" */ './polyfills/array-form');
}

/**
 * Accordion
 */
if (document.querySelector('.js-accordion')) {
  const accordions = document.querySelectorAll('.js-accordion');

  import(/* webpackChunkName: "accordion" */ 'badger-accordion').then(({default: Accordion}) => {
    Array.from(accordions).forEach((accordion) => {
      new Accordion(accordion, {
        headerClass: '.js-accordion-header',
        panelClass: '.js-accordion-panel',
        panelInnerClass: '.js-accordion-panel-inner',
        initalisedClass: 'accordion--initalised',
        headerDataAttr: 'data-accordion-header-id'
      });
    });
  });
}

/**
 * Slider
 */

if (document.querySelector('.js-carousel')) {
  const sliders = document.querySelectorAll('.js-carousel');

  import(/* webpackChunkName: "carousel" */ '@glidejs/glide').then(({default: Glide}) => {
    Array.from(sliders).forEach(carousel => {
      const items = carousel.dataset.carouselItems || 1;

      new Glide('.js-carousel', {
        type: 'carousel',
        gap: 20,
        perView: items,
        breakpoints: {
          800: {
            perView: (items - 1 > 0) ? items - 1 : 1,
          },
          480: {
            perView: (items - 2 > 0) ? items - 2 : 1
          }
        },
        classes: {
          direction: {
            ltr: 'carousel--ltr',
            rtl: 'carousel--rtl'
          },
          slider: 'carousel--slider',
          carousel: 'carousel--carousel',
          swipeable: 'carousel--swipeable',
          dragging: 'carousel--dragging',
          cloneSlide: 'carousel__slide--clone',
          activeNav: 'carousel__bullet--active',
          activeSlide: 'carousel__slide--active',
          disabledArrow: 'carousel__arrow--disabled'
        }
      }).mount()
    });
  });
}

/**
 * Lightbox
 */
if (document.querySelectorAll('.gallery, .entry-content > p > a')) {
  import(/* webpackChunkName: "baguettebox" */ 'baguettebox.js').then((baguetteBox) => {
    baguetteBox.run('.gallery, .entry-content > p > a');
  });
}

/**
 * Lazy loading with laysizes
 */

if(document.querySelector('.lazyload')) {
  import(/* webpackChunkName: "lazysizes" */ 'lazysizes');
}


/**
 * Overlay
 */

if(document.querySelector('.js-overlay')) {
  import(/* webpackChunkName: "overlay" */ './modules/overlay');
}

/**
 * File Input
 */

if(document.querySelector('.js-file-input')) {
  import(/* webpackChunkName: "file-input" */ './modules/file-input');
}

/**
 * Sticky Navigation
 * @type {Element}
 */
if(document.querySelector('.js-navigation-sticky')) {
  import(/* webpackChunkName: "navigation-sticky" */ './modules/navigation-sticky');
}
